module.exports = __webpack_public_path__ + "img/total-redemptions.cd0055ef.svg";